module.exports = __webpack_public_path__ + "static/media/arm-left-front.f748c1bd.png";